import React from "react";

import TextField from "../FormInputFields/TextField";
import TextArea from "../FormInputFields/TextArea";
import Checkbox from "../FormInputFields/Checkbox";
import Radio from "../FormInputFields/Radio";
import Dropdown from "../FormInputFields/Dropdown";
import DateField from "../FormInputFields/DateField";
import NumberField from "../FormInputFields/NumberField";
import CurrencyField from "../FormInputFields/CurrencyField";

const SectionContent = (props) => {
  switch (props.sectionItem.inputType) {
    case "TextField":
      return (
        <TextField
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    case "TextArea":
      return (
        <TextArea
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    case "Checkbox":
      return (
        <Checkbox
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          addOptionHandler={props.addOptionHandler}
          updateOptionValue={props.updateOptionValue}
          deleteOptionsHandler={props.deleteOptionsHandler}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    case "Radio":
      return (
        <Radio
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          addOptionHandler={props.addOptionHandler}
          updateOptionValue={props.updateOptionValue}
          deleteOptionsHandler={props.deleteOptionsHandler}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    case "Dropdown":
      return (
        <Dropdown
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          addOptionHandler={props.addOptionHandler}
          updateOptionValue={props.updateOptionValue}
          deleteOptionsHandler={props.deleteOptionsHandler}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    case "Date":
      return (
        <DateField
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    case "Number":
      return (
        <NumberField
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    case "Currency":
      return (
        <CurrencyField
          fieldItem={props.sectionItem}
          updatedField={props.updatedField}
          copyFieldHandler={props.copyFieldHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={props.errors}
          index={props.index}
          sectionId={props.sectionId}
          mode={props.mode}
          deleteFieldHandler={props.deleteFieldHandler}
        />
      );
    default:
      return null;
  }
};

export default SectionContent;
